import { useMutation, useQueryClient } from '@tanstack/react-query'
import { regenerateSoapFromAudio } from '@/shared/apis/yakureki'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { useToast } from '@/shared/contexts/ToastContext'

// 旧 path (= 音声 reprocess / transcribe → SOAP の一気通貫) の latest 用 mutation.
// FAILED 薬歴の復旧導線 (PostRecordingView の失敗バナー) から call.
//
// back guard:
//   - status == FAILED
//   - 保存済み音声が存在する
//   - regenerate_count < 3
// それ以外は HTTP error (= guard 種別ごとに toast 文言を切替).
//
// 成功 toast は出さない (= status が processing に戻り、生成中表示が状態を伝える.
// polling は詳細 poll query の refetchInterval で自動継続).
export const useRegenerateFromAudioMutation = () => {
  const queryClient = useQueryClient()
  const { showToast } = useToast()

  return useMutation({
    mutationFn: async (yakurekiId: string) => {
      await regenerateSoapFromAudio(yakurekiId)
    },
    onSuccess: (_, yakurekiId) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.yakureki.detail(yakurekiId),
      })
    },
    onError: (error) => {
      const axiosError = error as {
        response?: { status?: number; data?: { error?: string } }
      }
      const status = axiosError.response?.status
      // guard 失敗 (RegenerateError) は back が日本語 message を返す (= 文言の SSoT).
      const serverMessage = axiosError.response?.data?.error
      if (status === 404) {
        showToast('指定された薬歴が見つかりません', 'error')
      } else if (serverMessage) {
        showToast(serverMessage, 'warning')
      } else if (!navigator.onLine) {
        showToast('ネットワーク接続を確認してください', 'error')
      } else {
        showToast('SOAP 再生成に失敗しました', 'error')
      }
    },
  })
}
